export default "__VITE_ASSET__B4mDq_hA__"